import * as L from "leaflet"
import { GestureHandling } from "leaflet-gesture-handling"
import "leaflet/dist/leaflet.css"
import "leaflet-gesture-handling/dist/leaflet-gesture-handling.css"

const setProvider = (map) => {
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19
  }).addTo(map)
}
const addMarker = (map, lat, long) => {
  const pin = L.icon({
    iconUrl: '/dist/img/default/pin.png',
    iconSize: [30],
  })

  const marker = L.marker([lat, long],
  {
    icon: pin
  }).addTo(map)

  marker.addEventListener('click', () => {
    const coordinates = marker.getLatLng()

    map.setView([coordinates['lat'], coordinates['lng']], 15)
  })
}
const fixHeight = (map) => {
  setTimeout(() => {
    map.invalidateSize()
  }, 100)
}
const addGestureHandling = (map) => {
  L.Map.addInitHook("addHandler", "gestureHandling", GestureHandling)
}
const setBounds = (currentMap, map) => {
  const coordinates = JSON.parse(currentMap.getAttribute('coordinates'))
  let boundsList = []

  coordinates.forEach((coordinate, i) => {
    boundsList[i] =  [coordinate[0], coordinate[1]]
    addMarker(map, coordinate[0], coordinate[1])
  })

  map.fitBounds(boundsList)
}
const openFancybox = () => {
  const popFilters = document.querySelector('[data-src="#pop-filters"]')

  popFilters.addEventListener('click', () => {
    window.dispatchEvent(new Event('resize'))
  })
}

const extras = (currentMap, map) => {
  addGestureHandling(map)
  fixHeight(map)
  setProvider(map)
  setBounds(currentMap, map)
  // openFancybox()
}

const Map = () => {
  const maps = document.querySelectorAll('[map]')

  if (!maps.length > 0) return

  maps.forEach((map) => {
    const currentMap = map

    map = L.map(map, {
      center: [40.4176783, -3.7023926],
      zoom: 14,
      gestureHandling: true
    })

    extras(currentMap, map)
  })
}
export default Map
